import { isArray, isFunction } from "@visactor/vutils";

export function getCustomMergeCellFunc(customMergeCell) {
    return isFunction(customMergeCell) ? customMergeCell : isArray(customMergeCell) ? (col, row) => customMergeCell.find((item => item.range.start.col <= col && item.range.end.col >= col && item.range.start.row <= row && item.range.end.row >= row)) : void 0;
}
//# sourceMappingURL=get-custom-merge-cell-func.js.map
